export enum HeadersEnum {
  ACCION = 'accion',
  USUARIO = 'user'
}
